// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import { formatMessage as formatMessageFun } from "./locales/index";
// import Vconsole from "vconsole";
// const vConsole = new Vconsole();
// Vue.use(ElementUI)
Vue.use(ElementUI, { size: "small" });
Vue.prototype.formatMessage = function(data) {
  return formatMessageFun(data);
};
Vue.config.productionTip = false;
// Vue.use(vConsole);
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store: store,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js